module.exports = __webpack_public_path__ + "static/media/5-5.d32eb62c.mp3";